(function(){
  const init = () => {
    const sliderEl=document.querySelector(".js-media-list");
    if(!sliderEl)return;
    const subSliderEl=document.querySelector(".js-media-sublist"),
          desktopType=sliderEl.dataset?.desktopType||"slider",
          mobileType=sliderEl.dataset?.mobileType||"true";
    
    if(desktopType==="thumbs_aside"){
      let swiperInit2=function(){
        if(typeof subSliderInit === 'function') subSliderInit(!0);
        if(typeof sliderInit === 'function') sliderInit(!0);
        if(typeof popupSubSliderInit === 'function') popupSubSliderInit(!0);
        if(typeof popupSliderInit === 'function') popupSliderInit(!0);
      };
      var swiperInit=swiperInit2;
      document.addEventListener("shopify:section:load",function(e){swiperInit2()});
      if(!window.isSwiperInit) swiperInit2();
      window.isSwiperInit=!0;
    } else {
      let swiperInit2=function(){
        if(typeof subSliderInit === 'function') subSliderInit(!0);
        if(typeof sliderInit === 'function') sliderInit(!0);
      },
      popupswiperInit2=function(){
        if(typeof popupSubSliderInit === 'function') popupSubSliderInit(!0);
        if(typeof popupSliderInit === 'function') popupSliderInit(!0);
      },
      swiperDestroy2=function(){
        sliderEl.swiper&&sliderEl.swiper.destroy(!0,!0);
        subSliderEl.swiper&&subSliderEl.swiper.destroy(!0,!0);
      },
      checkSwiper2=function(){
        const isMobile=window.innerWidth<990;
        if(mobileType&&isMobile&&!window.isSwiperInit){
          swiperInit2();
          window.isSwiperInit=!0;
        }
        if(!isMobile){
          window.isSwiperInit=!1;
        }
        wasMobile=isMobile;
      };
      var swiperInit=swiperInit2,popupswiperInit=popupswiperInit2,swiperDestroy=swiperDestroy2,checkSwiper=checkSwiper2;
      if(!sliderEl)return;
      let wasMobile=window.innerWidth<990;
      document.addEventListener("shopify:section:load",function(){checkSwiper2(),popupswiperInit2()});
      checkSwiper2();
      window.addEventListener("resize",function(){
        const isMobile=window.innerWidth<990;
        if(isMobile!==wasMobile) checkSwiper2();
        if(!isMobile&&desktopType!="thumbs_aside") swiperDestroy2();
      });
      if(!window.isPopSwiperInit) popupswiperInit2();
      window.isPopSwiperInit=!0;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
